import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import "./AgencyHome.css";

const caseStudies = [
  {
    name: "Nick Vrysellas",
    company: "Elevate Realty",
    quote:
      "Apto Websites boosted my brand and helped increase lead flow with a cleaner, faster website experience.",
    website: "https://uvhomes.ca"
  },
  {
    name: "Nezam Ayam",
    company: "RE/MAX Hallmark First Group Realty",
    quote:
      "Switching to Apto's hosting was seamless. Better speed, better support, and a stronger digital presence.",
    website: "https://ayamhomes.com"
  },
  {
    name: "Wael Elzarka",
    company: "Right at Home Realty",
    quote:
      "Our market position improved with a polished site that loads quickly and presents listings professionally.",
    website: "https://waelelzarkarealty.ca"
  }
];

const latestWork = [
  {
    title: "Luxury Agent Experience",
    image: require("../../assets/imgs/previews/agent/luxury.jpg"),
    link: "/agent-templates"
  },
  {
    title: "Modern Brokerage Platform",
    image: require("../../assets/imgs/previews/agent/metropolitan.jpg"),
    link: "/brokerage-templates"
  },
  {
    title: "Bold Conversion Landing Page",
    image: require("../../assets/imgs/previews/agent/vibrance.jpg"),
    link: "/landing-pages"
  }
];

const serviceCards = [
  {
    title: "Real Estate SEO",
    description:
      "Rank for high-intent local searches with strategy, technical improvements, and content execution.",
    href: "/seo"
  },
  {
    title: "Branding",
    description:
      "Build a premium identity with cohesive web visuals, messaging direction, and conversion-focused UX.",
    href: "/branding"
  },
  {
    title: "Social Media",
    description:
      "Maintain consistent visibility with strategic social posting, creative assets, and monthly reporting.",
    href: "/socials"
  }
];

export default function AgencyHome() {
  return (
    <>
      <Helmet>
        <title>Apto Websites | Real Estate Web Design, SEO & Branding</title>
        <meta
          name="description"
          content="Apto Websites helps agents, teams, and brokerages grow with modern real estate websites, SEO, branding, and social media services."
        />
      </Helmet>

      <div className="agency-home">
        <section className="agency-hero">
          <div className="agency-hero-content">
            <p className="agency-kicker">Performance platform for real estate growth</p>
            <h1>Real Estate Websites, SEO & Branding That Win Markets</h1>
            <p>
              Apto Websites helps agents, teams, and brokerages attract better leads with custom web design,
              search visibility, and conversion-focused digital marketing.
            </p>
            <div className="agency-hero-actions">
              <Link to="/pricing" className="agency-btn primary">See Pricing</Link>
              <Link to="/templates" className="agency-btn secondary">Explore Templates</Link>
            </div>
          </div>
          <div className="agency-hero-media">
            <img
              src={require("../../assets/imgs/previews/agent/skyline.jpg")}
              alt="Modern real estate website preview"
            />
          </div>
        </section>

        <section className="agency-services-overview">
          <div className="agency-section-header">
            <p className="agency-kicker">What we deliver</p>
            <h2>Specialized Services for Real Estate Professionals</h2>
          </div>
          <div className="agency-service-grid">
            {serviceCards.map((card) => (
              <article key={card.title} className="agency-service-card">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <Link to={card.href}>Learn More</Link>
              </article>
            ))}
          </div>
        </section>

        <section className="agency-showcase">
          <div className="agency-section-header left">
            <p className="agency-kicker">Recent projects</p>
            <h2>Our Latest Work</h2>
          </div>
          <div className="agency-showcase-grid">
            {latestWork.map((item) => (
              <Link to={item.link} className="agency-work-card" key={item.title}>
                <img src={item.image} alt={item.title} />
                <div className="agency-work-overlay">
                  <h3>{item.title}</h3>
                  <span>View Portfolio</span>
                </div>
              </Link>
            ))}
          </div>
        </section>

        <section className="agency-case-studies">
          <div className="agency-section-header">
            <p className="agency-kicker">Proven outcomes</p>
            <h2>Case-Study Style Success Stories</h2>
          </div>
          <div className="agency-case-grid">
            {caseStudies.map((study) => (
              <article className="agency-case-card" key={study.name}>
                <span className="agency-case-quote-icon">&#8220;</span>
                <p className="agency-case-quote">{study.quote}</p>
                <div className="agency-case-meta">
                  <strong>{study.name}</strong>
                  <span className="agency-case-company">{study.company}</span>
                </div>
                <a href={study.website} target="_blank" rel="noopener noreferrer" className="agency-case-link">
                  Visit Website
                </a>
              </article>
            ))}
          </div>
        </section>

        <section className="agency-highlight-strip">
          <div className="agency-highlight-card">
            <h3>SEO for Real Estate</h3>
            <p>
              Structured on-page optimization, local market targeting, and technical audits to help you rank and convert.
            </p>
            <Link to="/seo">Explore SEO Services</Link>
          </div>
          <div className="agency-highlight-card">
            <h3>Branding That Makes You Memorable</h3>
            <p>
              Design language, messaging, and visuals built for trust, recognition, and consistent lead conversion.
            </p>
            <Link to="/branding">Explore Branding Services</Link>
          </div>
        </section>

        <section className="agency-final-cta">
          <h2>Ready to grow your real estate business online?</h2>
          <p>
            Start with a plan that fits your stage and scale with SEO, branding, and social support.
          </p>
          <div className="agency-hero-actions">
            <Link to="/pricing" className="agency-btn primary">Get Started</Link>
            <Link to="/signup" className="agency-btn secondary">Sign Up</Link>
          </div>
        </section>
      </div>
    </>
  );
}
